import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilserviceService } from 'app/services/utilservice.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.scss', '../login/login.component.scss']
})
export class ResetpasswordComponent implements OnInit {
  style: any;
  resetCode: string;
  resetForm: FormGroup;
  logo: string;
  constructor(private route: ActivatedRoute, private router: Router, private util: UtilserviceService, private fb: FormBuilder) { }

  ngOnInit(): void {
    this.style = this.util.getDomainEnviroment().style;
    this.logo = this.util.getDomainEnviroment().landingPageLogo;
    this.route.queryParams.subscribe(params => {
      this.resetCode = params['code'] || null;
    });
    this.resetForm = this.fb.group({
      password: ['', [Validators.required]],
      passwordII: ['', [Validators.required]]
    },
    {      
      validators: this.util.passwordMatchValidator
    }); 
  }

  async resetPassword(){
    if(this.resetCode){
      const formValue = this.resetForm.value;      
      let body = {
        password: formValue.password,
        code: this.resetCode
      }
      var data = await this.util.resetPassword(body);
      if(data.token){
        this.util.setAuthenticatedUserToken(data);
        this.router.navigateByUrl("/dashboard");
      }
    }
    else
      return;
  }

}
